<template>
  <div :class="['waitlist-container']">
    <div id="waitlist-form"></div>
  </div>
</template>

<script>
import { createWidget } from "@typeform/embed";
import "@typeform/embed/build/css/widget.css";

export default {
  name: "Waitlist",
  components: {},
  data() {
    return {
    };
  },
  computed: {
    
  },
  created() {
  },
  mounted() {
    this.createTypeform();
  },
  methods: {
    createTypeform() {
      createWidget("uKfIs4vn", {
        container: document.querySelector("#waitlist-form"), // you need an element with 'form' id
        hideHeaders: true,
        hideFooter: true,
        opacity: 0,
      });
    },
  },
  head() {
    return {
      title: "Join Waitlist",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Join Waitlist",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "Network currently in Alpha.",
        },
        {
          name: "description",
          content: "Network currently in Alpha.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "Network currently in Alpha.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Join Waitlist",
        },
      ],
    };
  },
};
</script>

<style scoped>

.waitlist-container {
  position: absolute;
  height: 100%;
  width: 100%;
}

#waitlist-form {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

</style>
